import { render, staticRenderFns } from "./categoria.vue?vue&type=template&id=488d461c&"
import script from "./categoria.vue?vue&type=script&lang=js&"
export * from "./categoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports